import { z } from 'zod';

export const ValidateAccessCodeInputSchema = z.object({
  bookingId: z.string().uuid(),
  code: z.string().min(1).max(20),
});

export type ValidateAccessCodeInput = z.infer<typeof ValidateAccessCodeInputSchema>;

export const ListAccessCodesQuerySchema = z.object({
  gymId: z.string().uuid().optional(),
  status: z.enum(['ACTIVE', 'USED', 'EXPIRED', 'REVOKED']).optional(),
  page: z.coerce.number().int().min(1).optional(),
  limit: z.coerce.number().int().min(1).max(100).optional(),
});

export type ListAccessCodesQuery = z.infer<typeof ListAccessCodesQuerySchema>;
